export const COMPANY = {
  legalName: "VECTRON GLOBAL LLP",
  gstin: "24ABCFV5326K1Z1",
  email: "vectronglobal@gmail.com",
  addressLines: ["352/1, 353, FF-8, Jayraj Complex, Odhav Road, Odhav", "Ahmedabad, Gujarat 382415, India"],
};
